/* KrutiKala material detail — FAQ + SEO + AJAX collection filters */
'use strict';

(function () {
  document.querySelectorAll('[data-kk-mat-faq]').forEach(function (list) {
    list.querySelectorAll('[data-kk-mat-faq-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.kk-mat-faq__item');
        if (!item) return;
        var open = item.classList.contains('is-open');
        list.querySelectorAll('.kk-mat-faq__item').forEach(function (el) {
          el.classList.remove('is-open');
          var b = el.querySelector('[data-kk-mat-faq-btn]');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  document.querySelectorAll('[data-kk-mat-seo]').forEach(function (section) {
    function openSeo() {
      section.classList.add('is-open');
      var toggle = section.querySelector('[data-kk-mat-seo-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
    var toggle = section.querySelector('[data-kk-mat-seo-toggle]');
    var more = section.querySelector('[data-kk-mat-seo-more]');
    if (toggle) toggle.addEventListener('click', openSeo);
    if (more) more.addEventListener('click', openSeo);
  });

  document.querySelectorAll('[data-kk-material-tabs]').forEach(function (section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-kk-material-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-kk-material-panel]'));

    function activate(index, moveFocus) {
      tabs.forEach(function (tab, tabIndex) {
        var active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        if (panels[tabIndex]) panels[tabIndex].hidden = !active;
      });
      if (moveFocus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        activate(next, true);
      });
    });
  });

  if (window.__kkMatShopBound) return;
  window.__kkMatShopBound = true;

  var pending = null;
  var requestId = 0;
  var priceTimer = null;

  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  function sectionRoot(sectionId) {
    return document.getElementById('shopify-section-' + sectionId);
  }

  function sanitizePrice(value) {
    return String(value || '').replace(/[^\d.]/g, '');
  }

  function isPriceInput(input) {
    return !!(input && input.name && input.name.indexOf('price') !== -1);
  }

  function cleanParams(form) {
    var params = new URLSearchParams(new FormData(form));
    var fields = [];
    if (form.id) {
      document.querySelectorAll('[form="' + CSS.escape(form.id) + '"]').forEach(function (input) {
        fields.push(input);
      });
    }
    form.querySelectorAll('input').forEach(function (input) {
      fields.push(input);
    });
    Array.prototype.forEach.call(fields, function (input) {
      if (!input || !input.name || input.disabled) return;
      if (!isPriceInput(input)) return;
      var cleaned = sanitizePrice(input.value);
      if (cleaned) params.set(input.name, cleaned);
      else params.delete(input.name);
    });
    ['filter.v.price.gte', 'filter.v.price.lte', 'filter.p.price.gte', 'filter.p.price.lte', 'sort_by'].forEach(function (key) {
      if (!params.get(key)) params.delete(key);
    });
    return params;
  }

  function pageUrlFrom(form, params) {
    var action = form.getAttribute('action') || window.location.pathname;
    var path = action.split('?')[0];
    var query = params.toString();
    return query ? path + '?' + query : path;
  }

  function fetchUrlFrom(form, params) {
    var action = form.getAttribute('action') || window.location.pathname;
    var path = action.split('?')[0];
    var sectionId = form.getAttribute('data-section-id');
    var search = new URLSearchParams(params.toString());
    if (sectionId) search.set('section_id', sectionId);
    return path + '?' + search.toString();
  }

  function loadSection(form, pageUrl, updateHistory) {
    var sectionId = form.getAttribute('data-section-id');
    var root = sectionRoot(sectionId);
    if (!root || !sectionId) {
      window.location.href = pageUrl;
      return;
    }

    if (pending) pending.abort();
    pending = new AbortController();
    var currentRequest = ++requestId;
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');

    var scrollY = window.scrollY;
    var url = fetchUrlFrom(form, new URLSearchParams(pageUrl.split('?')[1] || ''));

    fetch(url, { signal: pending.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Filter request failed');
        return response.text();
      })
      .then(function (html) {
        if (currentRequest !== requestId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('shopify-section-' + sectionId);
        if (!next) throw new Error('Section missing from response');
        root.replaceWith(next);
        if (typeof window.kkRevealAll === 'function') window.kkRevealAll(next);
        if (typeof window.kkInfiniteInit === 'function') window.kkInfiniteInit(next);
        window.scrollTo(0, scrollY);
        if (window.KKCart && typeof window.KKCart.syncButtons === 'function') window.KKCart.syncButtons();
        if (updateHistory !== false) {
          history.pushState({ kkMatShop: true, sectionId: sectionId }, '', pageUrl);
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError' || currentRequest !== requestId) return;
        window.location.href = pageUrl;
      })
      .finally(function () {
        if (currentRequest !== requestId) return;
        pending = null;
        var current = sectionRoot(sectionId);
        if (current) {
          current.classList.remove('is-loading');
          current.removeAttribute('aria-busy');
        }
      });
  }

  function applyFromForm(form, updateHistory) {
    loadSection(form, pageUrlFrom(form, cleanParams(form)), updateHistory);
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-kk-mat-open-filters]');
    if (openBtn) {
      var shop = openBtn.closest('.kk-mat-shop');
      var dialog = shop && shop.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    var closeBtn = event.target.closest('[data-kk-mat-close-filters]');
    if (closeBtn) {
      var dialog = closeBtn.closest('dialog');
      if (dialog && typeof dialog.close === 'function') dialog.close();
      return;
    }

    var clear = event.target.closest('[data-kk-mat-clear]');
    if (clear) {
      event.preventDefault();
      var shop = clear.closest('.kk-mat-shop') || clear.closest('[id^="shopify-section-"]');
      var form = shop && shop.querySelector('[data-kk-mat-filters]');
      if (!form) {
        window.location.href = clear.href;
        return;
      }
      var params = new URLSearchParams();
      var sort = form.querySelector('[name="sort_by"]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      loadSection(form, pageUrlFrom(form, params));
      return;
    }

    return;
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    var form = input.form;
    if (!form) return;

    if (form.hasAttribute('data-kk-mat-sort') && input.name === 'sort_by') {
      applyFromForm(form);
      return;
    }

    if (!form.hasAttribute('data-kk-mat-filters')) return;
    if (form.closest('dialog')) return;
    if (isPriceInput(input)) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        applyFromForm(form);
      }, 800);
      return;
    }

    applyFromForm(form);
  });

  document.addEventListener('input', function (event) {
    var input = event.target;
    var form = input.form;
    if (!form || !form.hasAttribute('data-kk-mat-filters')) return;
    if (form.closest('dialog')) return;
    if (!isPriceInput(input)) return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () {
      applyFromForm(form);
    }, 800);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target;
    if (!isPriceInput(input)) return;
    var form = input.form;
    if (!form || !form.hasAttribute('data-kk-mat-filters')) return;
    event.preventDefault();
    clearTimeout(priceTimer);
    applyFromForm(form);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.hasAttribute('data-kk-mat-filters') && !form.hasAttribute('data-kk-mat-sort')) return;
    event.preventDefault();
    var dialog = form.closest('dialog');
    if (dialog && typeof dialog.close === 'function') dialog.close();
    applyFromForm(form);
  });

  window.addEventListener('popstate', function () {
    var form = document.querySelector('[data-kk-mat-filters]');
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    params.delete('section_id');
    loadSection(form, pageUrlFrom(form, params), false);
  });
})();
